import styled from '@emotion/styled';
import { useEffect } from 'react';
import ReactDOM from 'react-dom';
import styleGuide from 'constants/styleGuide';
import useModalStore from 'zustands/useAlertConfirmStore';

const Wrap = styled.div`
  z-index: 2000;
  position: fixed;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`;
const Background = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
`;
const Container = styled.div`
  z-index: 1;
  display: flex;
  padding: 1.5% 2%;
  width: 350px;
  min-width: 15%;
  flex-direction: column;
  align-items: center;
  border-radius: 12px;
  background-color: #fff;
`;
const TitleArea = styled.div``;
const TitleText = styled.strong`
  font-size: 1.3rem;
  white-space: pre-line;
  text-align: center;
`;
const DescArea = styled.div`
  margin-top: 5%;
`;
const DescText = styled.span`
  color: #505054;
  white-space: pre-line;
`;
const BtnArea = styled.div`
  display: flex;
  margin-top: 10%;
  width: 100%;
`;
const Btn = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0.49;
  height: 4.5vh;
  border-radius: 8px;
  background-color: ${styleGuide.palette.backgroundGrey};
  &:hover {
    background-color: ${styleGuide.palette.backgroundGreyHover};
  }
`;
const OkBtn = styled(Btn)`
  &:hover {
    background-color: ${styleGuide.palette.primaryHover};
  }
`;
const BtnText = styled.strong`
  font-size: 1rem;
`;
const OkBtnText = styled(BtnText)`
  color: white;
`;
const Image = styled.img``;

const AlertConfirm = ({}) => {
  const {
    isModalShow,
    title,
    desc,
    descDiv,
    okBtnText = '확인',
    okCallback,
    isWarning,
    closeBtnText = '닫기',
    closeCallback,
    setModalState,
    image,
  } = useModalStore();

  const closeModal = (e?: React.MouseEvent<HTMLDivElement | HTMLButtonElement>) => {
    e?.stopPropagation();
    setModalState({ isModalShow: false });
    if (closeCallback) closeCallback();
  };

  const clickOkBtn = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (okCallback) okCallback();
    closeModal();
  };

  if (isModalShow === false) return null;
  return (
    <Wrap>
      <Background onClick={closeModal} />
      <Container>
        {title && title.length > 0 && (
          <TitleArea>
            <TitleText>{title}</TitleText>
          </TitleArea>
        )}
        {desc && desc.length > 0 && (
          <DescArea>
            <DescText>{desc}</DescText>
          </DescArea>
        )}
        {descDiv && <DescArea>{descDiv}</DescArea>}

        {image && image.url && image.url.length > 0 && image.width > 0 && image.height > 0 && (
          <DescArea>
            <Image src={image.url} style={{ width: image.width, height: image.height }} />
          </DescArea>
        )}
        <BtnArea style={{ justifyContent: okCallback ? 'space-between' : 'center' }}>
          <Btn onClick={closeModal} style={{ flex: okCallback ? 0.49 : 0.7 }}>
            <BtnText>{closeBtnText}</BtnText>
          </Btn>
          {okCallback && (
            <OkBtn
              onClick={clickOkBtn}
              style={{ backgroundColor: isWarning ? styleGuide.palette.redColor : styleGuide.palette.primary }}>
              <OkBtnText>{okBtnText}</OkBtnText>
            </OkBtn>
          )}
        </BtnArea>
      </Container>
    </Wrap>
  );
};

export default AlertConfirm;
